import { render, staticRenderFns } from "./ControlaTusCostos.vue?vue&type=template&id=946697d4&"
import script from "./ControlaTusCostos.vue?vue&type=script&lang=ts&"
export * from "./ControlaTusCostos.vue?vue&type=script&lang=ts&"
import style0 from "./ControlaTusCostos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports